import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Appt Components
import Box from '../../../components/simple/box/Box'
import Divider from '../../../components/simple/divider/Divider.js'
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid'
import Text from '../../../components/simple/text/Text'

import LocalStorageService from '../../../services/LocalStorageService.js'

// App widgets


import { Bar } from 'react-chartjs-2'
import { backgroundColours, borderColours } from '../common/colours.js'
const InvolvementReport = (props) => {
  const navigate = useNavigate()

  const [numberOfStaffInvolvedPerIncident, setNumberOfStaffInvolvedPerIncident] = useState(0)

  const [totalNumberOfIncidentsByDate, setTotalNumberOfIncidentsByDate] = useState([])

  const [otherChildrenInvolvedInIncident, setOtherChildrenInvolvedInIncident] = useState([])
  const [staffInvolvedInIncident, setStaffInvolvedInIncident] = useState([])

  const [averageNumberOfStaffPerIncidentByHour, setAverageNumberOfStaffPerIncidentByHour] = useState([])

  const [averageNumberOfStaffPerIncidentByLocation, setAverageNumberOfStaffPerIncidentByLocation] = useState([])

  const [relatedIncidents, setRelatedIncidents] = useState([]);

  const [staffAndWitnesses, setStaffAndWitnesses] = useState([])
  const [otherChildren, setOtherChildren] = useState([])

  const terms = LocalStorageService.get('terms')


  // Location
  const staffByLocation = {
    labels: averageNumberOfStaffPerIncidentByLocation[1],
    datasets: [
      {
        // label: '# of Votes',
        data: averageNumberOfStaffPerIncidentByLocation[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by Other Children
  const otherChildrenData = {
    labels: otherChildrenInvolvedInIncident[1],
    datasets: [
      {
        // label: '# of Votes',
        data: otherChildrenInvolvedInIncident[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by Other Children
  const staffData = {
    labels: staffInvolvedInIncident[1],
    datasets: [
      {
        // label: '# of Votes',
        data: staffInvolvedInIncident[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by Date
  const incidentsByDate = {
    labels: totalNumberOfIncidentsByDate[1], // ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan'],
    datasets: [
      {
        // label: '# of Incidents',
        data: totalNumberOfIncidentsByDate[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  // Incidents by hour
  const incidentsByHour = {
    labels: averageNumberOfStaffPerIncidentByHour[1], // ['00-01', '01-02', '02-03', '03-04', '04-05', '05-06', '06-07', '07-08', '08-09', '09-10', '10-11', '11-12', '12-13', '13-14', '14-15', '15-16'],
    datasets: [
      {
        // label: '# of Incidents',
        data: averageNumberOfStaffPerIncidentByHour[0],
        backgroundColor: backgroundColours,
        borderColor: borderColours,
        borderWidth: 1,
      },
    ],
  };

  const printScreen = () => {
    window.print()
  }

  useEffect(() => {
    // Map the API data in props.location.state into the relevant datasets

    // Staff per incident
    if (props?.reportData?.numberOfStaffInvolvedPerIncident) {
      const numberOfStaffInvolvedPerIncident = props?.reportData?.numberOfStaffInvolvedPerIncident
      if (numberOfStaffInvolvedPerIncident && numberOfStaffInvolvedPerIncident.length) {

        var average = 0
        var totalStaff = 0
        var totalCount = 0

        for (const record of numberOfStaffInvolvedPerIncident) {
          if (record.count) {
            totalStaff += record.numStaff * record.count
            totalCount += record.count
          }
        }
        average = Math.ceil(totalStaff / totalCount)
        setNumberOfStaffInvolvedPerIncident(average)
      }
    }

    // Staff
    if (props?.reportData?.staffInvolvedInIncident) {
      const staffInvolvedInIncident = props?.reportData?.staffInvolvedInIncident

      // Remove dupicates and add counts
      const staffCount = staffInvolvedInIncident.reduce((newArray, staff) => {
        const str = JSON.stringify(staff)
        newArray[str] = (newArray[str] || 0) + 1
        return newArray
      }, {})

      const staffInvolvedInIncidentLabels = []
      const staffInvolvedInIncidentData = []

      for (const x in staffCount) {
        staffInvolvedInIncidentLabels.push(JSON.parse(x).name)
        staffInvolvedInIncidentData.push(staffCount[x])
      }
      setStaffInvolvedInIncident([staffInvolvedInIncidentData, staffInvolvedInIncidentLabels])
    }

    // Other Children
    if (props?.reportData?.otherChildrenInvolvedInIncident) {
      const otherChildrenInvolvedInIncident = props?.reportData?.otherChildrenInvolvedInIncident

      // Remove dupicates and add counts
      const childrenCount = otherChildrenInvolvedInIncident.reduce((newArray, child) => {
        const str = JSON.stringify(child)
        newArray[str] = (newArray[str] || 0) + 1
        return newArray
      }, {})

      const otherChildrenInvolvedInIncidentLabels = []
      const otherChildrenInvolvedInIncidentData = []

      for (const x in childrenCount) {
        otherChildrenInvolvedInIncidentLabels.push(JSON.parse(x).name)
        otherChildrenInvolvedInIncidentData.push(childrenCount[x])
      }
      setOtherChildrenInvolvedInIncident([otherChildrenInvolvedInIncidentData, otherChildrenInvolvedInIncidentLabels])
    }

    // Date
    var totalNumberOfIncidentsByDateLabels = []
    var totalNumberOfIncidentsByDateData = []

    if (props?.reportData?.totalNumberOfIncidentsByDate) {
      const totalNumberOfIncidentsByDate = props?.reportData?.totalNumberOfIncidentsByDate
      if (totalNumberOfIncidentsByDate?.length) {
        totalNumberOfIncidentsByDateLabels = totalNumberOfIncidentsByDate.map((data, index) => {
          return data.month || 'n/a'
        })

        totalNumberOfIncidentsByDateData = totalNumberOfIncidentsByDate.map((data, index) => {
          return data.count
        })

        setTotalNumberOfIncidentsByDate([totalNumberOfIncidentsByDateData, totalNumberOfIncidentsByDateLabels])
      }
    }

    // staff / witnesses
    // Common Interventions
    if (props?.reportData?.otherChildrenInvolvedInIncident) {
      const otherChildrenInvolvedInIncident = props?.reportData?.otherChildrenInvolvedInIncident

      setOtherChildren(otherChildrenInvolvedInIncident)
    }

    // Time
    if (props?.reportData?.totalNumberOfIncidentsByHour) {
      const averageNumberOfStaffPerIncidentByHour = props?.reportData?.averageNumberOfStaffPerIncidentByHour

      const averageNumberOfStaffPerIncidentByHourLabels = []
      const averageNumberOfStaffPerIncidentByHourData = []

      // debugger

      for (var x in averageNumberOfStaffPerIncidentByHour) {
        if (x === 'null') { x = null }
        averageNumberOfStaffPerIncidentByHourLabels.push((x || 'n/a'))
        averageNumberOfStaffPerIncidentByHourData.push(averageNumberOfStaffPerIncidentByHour[x].numIncidents)
      }
      // const averageNumberOfStaffPerIncidentByHourLabels = averageNumberOfStaffPerIncidentByHour.map((data, index) => {
      //   return data.hour
      // })

      // const averageNumberOfStaffPerIncidentByHourData = averageNumberOfStaffPerIncidentByHour.map((data, index) => {
      //   return data.count
      // })

      setAverageNumberOfStaffPerIncidentByHour([averageNumberOfStaffPerIncidentByHourData, averageNumberOfStaffPerIncidentByHourLabels])
    }

    // Location
    if (props?.reportData?.averageNumberOfStaffPerIncidentByLocation) {
      const averageNumberOfStaffPerIncidentByLocation = props?.reportData?.averageNumberOfStaffPerIncidentByLocation

      const averageNumberOfStaffPerIncidentByLocationLabels = []
      const averageNumberOfStaffPerIncidentByLocationData = []

      for (const x in averageNumberOfStaffPerIncidentByLocation) {
        averageNumberOfStaffPerIncidentByLocationLabels.push(x)
        averageNumberOfStaffPerIncidentByLocationData.push(averageNumberOfStaffPerIncidentByLocation[x].numIncidents)
      }

      setAverageNumberOfStaffPerIncidentByLocation([averageNumberOfStaffPerIncidentByLocationData, averageNumberOfStaffPerIncidentByLocationLabels])
    }

    // if (props?.reportData?.incidentSearch) {
    //   setRelatedIncidents(props.location.state.incidentSearch);
    // }
  }, [props.reportData])

  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto'],
            large: ['auto'],
            xlarge: ['auto'],
          }}
          gap="small"
        >
          {/* {props?.reportData?.totalNumberOfIncidents ? (
            <SimpleCounter
              count={String(props.location.state.totalNumberOfIncidents)}
              label="Number of Incidents"
            />
          ) : (
            <SimpleCounter count="0" label="Number of Incidents" />
          )} */}

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Staff
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {staffInvolvedInIncident.length !== 0 ? (
              <Bar
                data={staffData}
                height={25}
                legend={{ display: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'completedBy';
                  let value = props?.reportData?.staffInvolvedInIncident?.[_index]?.id
                  props.addFilter(key, value);
                }}
                // options={{ maintainAspectRatio: false }}
                width={50}
              />
            ) : (
              <Text textAlign="center">No data available</Text>
            )}
          </Box>

          <Box background="white" direction="column" pad="small" round="small">
            <Text size="medium" weight="bold">
              Other{' '}
              {terms?.serviceUser
                ? terms?.serviceUser?.charAt(0)?.toUpperCase() +
                  terms?.serviceUser?.slice(1)
                : 'Student'}
            </Text>
            <Divider
              color="primary"
              margin={{ top: 'none', bottom: 'small' }}
            />

            {otherChildrenInvolvedInIncident.length !== 0 ? (
              <Bar
                data={otherChildrenData}
                height={25}
                legend={{ display: false }}
                // options={{ maintainAspectRatio: false }}
                onElementsClick={(event) => {
                  if (!event.length) return;
                  const { _datasetIndex, _index } = event[0];
                  let key = 'studentsInvolved';
                  let value = props?.reportData?.otherChildrenInvolvedInIncident?.[_index]?.id
                  props.addFilter(key, value, 'contains');

                }}
                width={50}
              />
            ) : (
              <Text textAlign="center">No data available</Text>
            )}
          </Box>
        </ResponsiveGrid>
    </Box>
  );
}

export default InvolvementReport
